var map = {
	"./BUG.png": "289b",
	"./DARK.png": "3306",
	"./DRAGON.png": "5581",
	"./ELECTRIC.png": "1fda",
	"./FAIRY.png": "72f1",
	"./FIGHTING.png": "422f",
	"./FIRE.png": "565c",
	"./FLYING.png": "bc4b",
	"./GHOST.png": "e6de",
	"./GRASS.png": "c73a",
	"./GROUND.png": "0f0a",
	"./ICE.png": "1122",
	"./NORMAL.png": "8c64",
	"./POISON.png": "6949",
	"./PSYCHIC.png": "8119",
	"./ROCK.png": "8969",
	"./STEEL.png": "066d",
	"./WATER.png": "f2d1",
	"./logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";